import React, { useState, useEffect } from 'react'
import {
  Box,
  Typography,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  ListItem,
  ListItemText,
  Divider,
} from '@mui/material'
import api from '../../../config/api'

export const DeliveryAddressesSelect = ({
  selectedAddress,
  setSelectedAddress,
}) => {
  const [addresses, setAddresses] = useState([])
  const [loading, setLoading] = useState(false) // Для обработки состояния загрузки

  // Загрузка данных с API
  useEffect(() => {
    const loadAddresses = async () => {
      setLoading(true) // Начало загрузки
      try {
        const response = await api.get('/API_FRONT/user/locations/') // Эндпоинт для получения данных
        setAddresses(response.data)
      } catch (error) {
        console.error('Ошибка загрузки адресов:', error)
      } finally {
        setLoading(false) // Завершение загрузки
      }
    }
    loadAddresses()
  }, [])

  return (
    <Box sx={{ marginTop: 2 }}>
      <Typography variant="h6" gutterBottom>
        Выберите адрес доставки
      </Typography>
      <FormControl fullWidth variant="outlined" sx={{ marginTop: 1 }}>
        <InputLabel>Адрес</InputLabel>
        <Select
          value={selectedAddress || ''} // Если выбран пустой адрес, значение будет пустым
          onChange={(e) => setSelectedAddress(e.target.value)}
          label="Адрес"
          disabled={loading || addresses.length === 0} // Отключение, если идет загрузка или данных нет
          renderValue={(value) => {
            if (!value) return 'Не выбран' // Отображение, если ничего не выбрано
            const selected = addresses.find((addr) => addr.id === value)
            return selected
              ? `г. ${selected.city}, ${selected.address || selected.location}`
              : 'Выберите адрес'
          }}
        >
          <MenuItem value="">
            <em>Не выбран</em> {/* Элемент для сброса выбора */}
          </MenuItem>
          {loading ? (
            <MenuItem disabled>Загрузка адресов...</MenuItem>
          ) : addresses.length > 0 ? (
            addresses.map((addr, index) => (
              <MenuItem key={addr.id} value={addr.id} sx={{ padding: 0 }}>
                <React.Fragment>
                  <ListItem>
                    <ListItemText
                      primary={`г. ${addr.city}`}
                      secondary={addr.address || addr.location}
                    />
                  </ListItem>
                  <Divider />
                </React.Fragment>
              </MenuItem>
            ))
          ) : (
            <MenuItem disabled>Адреса не найдены</MenuItem>
          )}
        </Select>
      </FormControl>
    </Box>
  )
}
